import { render, staticRenderFns } from "./prevLessonTitle.vue?vue&type=template&id=f23651d0&"
import script from "./prevLessonTitle.vue?vue&type=script&lang=js&"
export * from "./prevLessonTitle.vue?vue&type=script&lang=js&"
import style0 from "./prevLessonTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports